angular.module('picmonic-common').factory('GroupBuyService', [
  '$interval',
  '$cookies',
  'MarketOptionsConfig',
  'UserService',
  'User',
  'GroupBuyResource',
  'PackageOptionsResource',
  '$rootScope',
  '$filter',
  'SplitTestService',
  '$modal',
  'ngBowser',
  function (
    $interval,
    $cookies,
    MarketOptionsConfig,
    UserService,
    User,
    GroupBuyResource,
    PackageOptionsResource,
    $rootScope,
    $filter,
    SplitTestService,
    $modal,
    ngBowser
  ) {
    return {
      referral_url: '',
      group_buy: {},
      //when changing change in groupbuy php model and groupbuycontext in website
      defaultValues: {
        goal: 5,
        discount_before_goal: 15,
        discount_after_goal: 30,
      },
      init: function () {
        var self = this;
        if (self.group_buy.$promise) {
          return self.group_buy.$promise;
        }

        self.group_buy = User.getv3({ resource: 'group_buy' }, function (data) {
          var pathArray = location.href.split('/');
          var protocol = pathArray[0];
          var host = pathArray[2];
          var url = protocol + '//' + host;

          self.referral_url = url + '/gb/' + data.slug;
          $interval.cancel(self.interval);
          self.interval = $interval(
            function () {
              self.group_buy.time_left--;
            },
            1000,
            self.group_buy.time_left
          );
        });
      },
      getBySlug: function (slug) {
        var self = this;
        self.group_buy = GroupBuyResource.get({ slug: slug }, function () {
          $interval.cancel(self.interval);
          self.interval = $interval(
            function () {
              self.group_buy.time_left--;
            },
            1000,
            self.group_buy.time_left
          );
        });
        return self.group_buy.$promise;
      },
      launch: function (slugOrId, keepCookie) {
        var self = this;

        var market_id = typeof slugOrId === 'string' ? MarketOptionsConfig.getMarketBySlug(slugOrId).id : slugOrId;

        if (!market_id) {
          var lead = UserService.user.lead || $cookies.get('pls_user_lead');

          if (lead) {
            market_id = MarketOptionsConfig.getMarketById(lead).id;
          } else {
            self.openUrl('/gb', 'Pricing');
          }
        }

        self.plans = PackageOptionsResource.query(
          { market_id: market_id, group_id: 1, is_group_buy: 1 },
          function (data) {
            // If they don't have any Group Buy options send to pricing page
            if (!data.length) {
              var market = MarketOptionsConfig.getMarketById(market_id);

              if (market.is_beta) {
                self.openUrl('/pricing/beta?market=' + market.slug, 'Pricing');
              } else {
                self.openUrl('/pricing/' + market.slug, 'Pricing');
              }
            }

            // Go to lowest Group Buy package
            var selectedPlan = data[0];

            angular.forEach(data, function (value) {
              if (value.price < selectedPlan.price) {
                selectedPlan = value;
              }
            });

            if (!keepCookie) {
              $cookies.remove('pls_user_group_buy', {
                path: '/',
                domain: '.picmonic.com',
              });
            }

            var inIframe = false;
            try {
              inIframe = window.self !== window.top;
            } catch (e) {
              inIframe = true;
            }

            if (!inIframe) {
              self.openUrl('/store/' + selectedPlan.slug, 'Checkout');
            } else {
              window.location = '/store/' + selectedPlan.slug;
            }
          }
        );
      },
      openUrl: function (url, title) {
        if (ngBowser.isDesktop()) {
          var modal = $modal.open({
            windowClass: 'pls-how-it-works-modal',
            backdropClass: 'above-nav',
            size: 'lg',
            template:
              '<div class="modal-header p-b-6">\
                                    <i class="material-icons pull-right pls-wet-cement" role="button" tabindex="0" ng-click="$close()">close</i>\
                                    <span class="modal-header-title">' +
              title +
              '</span>\
                                </div>\
                                <div class="modal-body" style="padding-top:63px;overflow-y: hidden;"><iframe id="pricing_modal" src="' +
              url +
              '" style="width:100%; min-height:85vh; height:100%; border:none; margin-bottom:-4px;"></iframe>',
          });

          // Refresh the page on modal close if we set refresh on the thank you page.
          modal.result.finally(function () {
            if (window.refresh) {
              location.reload();
            }
          });
        } else {
          window.location = url;
        }
      },
      shareOnFacebook: function () {
        var self = this,
          url = self.referral_url,
          splittest;

        if (self.group_buy.goal > self.group_buy.users.length) {
          url += '?src=facebook-share-pre-a-v4';
        } else {
          url += '?src=facebook-share-post-a-v4';
        }

        FB.ui(
          {
            method: 'feed',
            link: url,
          },
          function (response) {
            if (response && !response.error_message) {
              if (typeof atlasEvent !== 'undefined') {
                atlasEvent('share', 'Group Buy - facebook');
              }
            }
          }
        );
      },
      openShareModal: function () {
        $modal.open({
          templateUrl: '/templates/modals/group-buy-email-share.html',
          backdrop: true,
          windowClass: 'gb-share-modal',
          controller: [
            '$scope',
            'GroupBuyResource',
            'GroupBuyService',
            '$http',
            '$filter',
            function ($scope, GroupBuyResource, GroupBuyService, $http, $filter) {
              $scope.emails = [];
              $scope.contacts = [];
              $scope.step = 'send-invites';

              $scope.google = function () {
                var config = {
                  client_id: pls_config.google_client_id,
                  scope: 'https://www.googleapis.com/auth/contacts.readonly',
                };

                gapi.auth.authorize(config, function () {
                  $http
                    .get(
                      'https://www.google.com/m8/feeds/contacts/default/full?max-results=5000&access_token=' +
                        gapi.auth.getToken().access_token +
                        '&alt=json',
                      {
                        headers: {
                          'X-Requested-With': undefined,
                          'If-Modified-Since': undefined,
                        },
                      }
                    )
                    .then(function (response) {
                      angular.forEach(response.data.feed.entry, function (contact) {
                        angular.forEach(contact['gd$email'], function (email) {
                          $scope.contacts.push({
                            name: contact.title.$t,
                            email: email.address,
                          });
                        });
                      });
                      $scope.step = 'select-imports';
                    });
                });
              };

              $scope.yahoo = function () {
                var contacts = $q(function (resolve, reject) {
                  $scope.openPopUp(
                    'https://api.login.yahoo.com/oauth2/request_auth?response_type=token&redirect_uri=https://' +
                      location.hostname +
                      '/oauth/yahoo.html&client_id=' +
                      pls_config.yahoo_client_id,
                    450,
                    675
                  );

                  window.oAuthTokenCB = function (token) {
                    $http
                      .get('/yahoo/v1/user/me/contacts?format=json&count=max', {
                        headers: {
                          'Authorization': 'Bearer ' + token,
                          'X-Requested-With': undefined,
                          'If-Modified-Since': undefined,
                        },
                      })
                      .then(function (response) {
                        resolve(response.data.contacts.contact);
                      });
                  };
                });
                contacts.then(function (contacts) {
                  angular.forEach(contacts, function (contact) {
                    var email = $filter('filter')(contact.fields, { type: 'email' }, true);
                    if (email.length) {
                      $scope.contacts.push({ name: '', email: email[0].value });
                    }
                  });
                  $scope.step = 'select-imports';
                });
              };

              $scope.microsoft = function () {
                var contacts = $q(function (resolve, reject) {
                  $scope.openPopUp(
                    'https://login.microsoftonline.com/common/oauth2/v2.0/authorize?' +
                      'response_type=token' +
                      '&scope=user.read%20contacts.read%20openid%20profile' +
                      '&client_id=' +
                      pls_config.microsoft_client_id +
                      '&redirect_uri=https%3A%2F%2F' +
                      location.hostname +
                      '%2Foauth%2Fyahoo.html' +
                      '&state=e8fcedaa-bdec-4124-bbb4-62f5ead7e3ab' +
                      '&nonce=3c4ccc42-ec27-4ea5-978b-a6bc248a1c24' +
                      '&client_info=1' +
                      '&x-client-SKU=MSAL.JS&x-client-Ver=0.1.1' +
                      '&client-request-id=5ddf7274-4615-4479-9f07-1a8cd92bf6be' +
                      '&prompt=select_account' +
                      '&response_mode=fragment',
                    450,
                    675
                  );

                  window.oAuthTokenCB = function (token) {
                    $http
                      .get('https://graph.microsoft.com/v1.0/me/contacts?$top=5000', {
                        headers: {
                          'Authorization': 'Bearer ' + token,
                          'X-Requested-With': undefined,
                          'If-Modified-Since': undefined,
                        },
                      })
                      .then(function (response) {
                        resolve(response.data.value);
                      });
                  };
                });
                contacts.then(function (contacts) {
                  angular.forEach(contacts, function (contact) {
                    angular.forEach(contact.emailAddresses, function (email) {
                      $scope.contacts.push({
                        name: contact.displayName,
                        email: email.address,
                      });
                    });
                  });
                  $scope.step = 'select-imports';
                });
              };

              $scope.openPopUp = function (url, w, h) {
                var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
                var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

                var width = window.innerWidth
                  ? window.innerWidth
                  : document.documentElement.clientWidth
                  ? document.documentElement.clientWidth
                  : screen.width;
                var height = window.innerHeight
                  ? window.innerHeight
                  : document.documentElement.clientHeight
                  ? document.documentElement.clientHeight
                  : screen.height;

                var left = width / 2 - w / 2 + dualScreenLeft;
                var top = height / 2 - h / 2 + dualScreenTop;

                window.open(
                  url,
                  'oauth_login',
                  'channelmode=1,height=' +
                    h +
                    ',left=' +
                    left +
                    ',scrollbars=0,location=0,menubar=0,resizable=0,status=0,toolbar=0,top=' +
                    top +
                    ',width=' +
                    w +
                    ''
                );
              };

              $scope.select = function (contact) {
                contact.selected = !contact.selected;
              };

              $scope.selectAll = function (value) {
                angular.forEach($scope.contacts, function (contact) {
                  contact.selected = value;
                });
              };

              $scope.addImports = function () {
                angular.forEach($scope.contacts, function (contact) {
                  if (contact.selected) {
                    $scope.emails.push(contact.email);
                  }
                });
                $scope.contacts = [];
                $scope.step = 'send-imports';
              };

              $scope.add = function () {
                if ($scope.email) {
                  $scope.email.split(',').forEach(function (item) {
                    if ($scope.emails.indexOf(item.trim()) === -1 && item.trim() !== '') {
                      $scope.emails.push(item.trim());
                    }
                  });
                  $scope.email = undefined;
                }
              };

              $scope.remove = function (email) {
                $scope.emails.splice($scope.emails.indexOf(email), 1);
              };

              $scope.send = function () {
                if (!$scope.loading && $scope.emails.length) {
                  $scope.loading = true;

                  GroupBuyResource.save(
                    {
                      slug: GroupBuyService.group_buy.slug,
                      resource: 'share',
                      comments: $scope.comments,
                      emails: $scope.emails,
                    },
                    function () {
                      $scope.emails = [];
                      $scope.complete = true;
                      $scope.step = 'complete';
                    }
                  ).$promise.finally(function () {
                    $scope.loading = false;
                  });
                }
              };
            },
          ],
        });
      },
      goToGroupBuyCheckout: function () {
        var self = this;

        if (UserService.user.lead) {
          self.launch(MarketOptionsConfig.getMarketById(UserService.user.lead).id);
        } else if ($cookies.get('pls_user_lead')) {
          self.launch(MarketOptionsConfig.getMarketById($cookies.get('pls_user_lead')).id);
        } else {
          $modal.open({
            template:
              '<div>\n' +
              '    <div class="bg-pls-abyss">\n' +
              '        <p class="pls-font-raleway pls-font-20 pls-wet-cement pull-left p-l-2 p-t-1"><strong ng-class="{\'pls-font-16\': fpt}">Select a subject...</strong></p>\n' +
              '        <div class="clearfix"></div>\n' +
              '    </div>\n' +
              '    <div class="bg-pls-deep-sea">\n' +
              '        <div ng-click="selectLead(market)" class="p-a-1 clickable" ng-repeat="market in markets">\n' +
              '            <span class="pls-white pull-left m-t-1">{{ market.public_name ? market.public_name : market.name }}</span> <a class="pls-btn pull-right">SELECT</a>\n' +
              '            <div class="clearfix"></div>\n' +
              '        </div>\n' +
              '        <div ng-class="{\'p-b-1\': $last}"></div>\n' +
              '    </div>\n' +
              '</div>',
            windowClass: 'market-selector',
            controller: [
              '$scope',
              '$filter',
              '$modalInstance',
              'MarketOptionsConfig',
              '$location',
              function ($scope, $filter, $modalInstance, MarketOptionsConfig, $location) {
                $scope.title = '';
                $scope.markets = $filter('filter')(MarketOptionsConfig.markets, { hidden: 0, is_beta: false }, true);

                $scope.selectLead = function (market) {
                  $cookies.put('pls_user_lead', market.id);
                  self.launch(market.slug);
                };
              },
            ],
          });
        }
      },
    };
  },
]);
